<div style="text-align: center;">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
